// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ResearchInterestSearchResults-cls1___66eda363f2aadf5b966{/*!*/}.ResearchInterestSearchResults-cls2___cc93aff46051f95b7df{color:#999;font-weight:300;font-size:85%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ResearchInterestSearchResults-cls1___66eda363f2aadf5b966",
	"cls2": "ResearchInterestSearchResults-cls2___cc93aff46051f95b7df ResearchInterestSearchResults-cls1___66eda363f2aadf5b966"
};
export default ___CSS_LOADER_EXPORT___;
